<template>
  <div class="flex flex-col">
    <h3 class="capitalize-first text-base font-bold">
      {{ $t('global.button.dashboard.agenda.time_slot') }}
    </h3>
    <div class="flex flex-row flex-wrap gap-2">
      <BaseButton
        v-for="predefined_slot in predefined_slots"
        :key="predefined_slot.label"
        :title="predefined_slot.label"
        size="extra-small"
        color="primary"
        :is-outline="timeSlotSelected !== predefined_slot.id"
        @click="timeSlotSelected = predefined_slot.id"
      />
    </div>
    <div v-if="timeSlotSelected === 'custom'" class="flex flex-row gap-2 pt-2">
      <div class="flex-1">
        <SelectComponent
          v-model="localSlotTime.min"
          :values="fromHours"
          name="min"
          display-key="label"
          track-by="value"
          required
        />
      </div>
      <div class="flex-1">
        <SelectComponent
          v-model="localSlotTime.max"
          :values="toHours"
          name="max"
          display-key="label"
          track-by="value"
          required
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import SelectComponent from '@c/BaseFormComponent/SelectComponent.vue'

let hours = [
  { label: '00:00', value: '00:00:00', compareValue: 0 },
  { label: '00:30', value: '00:30:00', compareValue: 30 },
  { label: '01:00', value: '01:00:00', compareValue: 60 },
  { label: '01:30', value: '01:30:00', compareValue: 90 },
  { label: '02:00', value: '02:00:00', compareValue: 120 },
  { label: '02:30', value: '02:30:00', compareValue: 150 },
  { label: '03:00', value: '03:00:00', compareValue: 180 },
  { label: '03:30', value: '03:30:00', compareValue: 210 },
  { label: '04:00', value: '04:00:00', compareValue: 240 },
  { label: '04:30', value: '04:30:00', compareValue: 270 },
  { label: '05:00', value: '05:00:00', compareValue: 300 },
  { label: '05:30', value: '05:30:00', compareValue: 330 },
  { label: '06:00', value: '06:00:00', compareValue: 360 },
  { label: '06:30', value: '06:30:00', compareValue: 390 },
  { label: '07:00', value: '07:00:00', compareValue: 420 },
  { label: '07:30', value: '07:30:00', compareValue: 450 },
  { label: '08:00', value: '08:00:00', compareValue: 480 },
  { label: '08:30', value: '08:30:00', compareValue: 510 },
  { label: '09:00', value: '09:00:00', compareValue: 540 },
  { label: '09:30', value: '09:30:00', compareValue: 570 },
  { label: '10:00', value: '10:00:00', compareValue: 600 },
  { label: '10:30', value: '10:30:00', compareValue: 630 },
  { label: '11:00', value: '11:00:00', compareValue: 660 },
  { label: '11:30', value: '11:30:00', compareValue: 690 },
  { label: '12:00', value: '12:00:00', compareValue: 720 },
  { label: '12:30', value: '12:30:00', compareValue: 750 },
  { label: '13:00', value: '13:00:00', compareValue: 780 },
  { label: '13:30', value: '13:30:00', compareValue: 810 },
  { label: '14:00', value: '14:00:00', compareValue: 840 },
  { label: '14:30', value: '14:30:00', compareValue: 870 },
  { label: '15:00', value: '15:00:00', compareValue: 900 },
  { label: '15:30', value: '15:30:00', compareValue: 930 },
  { label: '16:00', value: '16:00:00', compareValue: 960 },
  { label: '16:30', value: '16:30:00', compareValue: 990 },
  { label: '17:00', value: '17:00:00', compareValue: 1020 },
  { label: '17:30', value: '17:30:00', compareValue: 1050 },
  { label: '18:00', value: '18:00:00', compareValue: 1080 },
  { label: '18:30', value: '18:30:00', compareValue: 1110 },
  { label: '19:00', value: '19:00:00', compareValue: 1140 },
  { label: '19:30', value: '19:30:00', compareValue: 1170 },
  { label: '20:00', value: '20:00:00', compareValue: 1200 },
  { label: '20:30', value: '20:30:00', compareValue: 1230 },
  { label: '21:00', value: '21:00:00', compareValue: 1260 },
  { label: '21:30', value: '21:30:00', compareValue: 1290 },
  { label: '22:00', value: '22:00:00', compareValue: 1320 },
  { label: '22:30', value: '22:30:00', compareValue: 1350 },
  { label: '23:00', value: '23:00:00', compareValue: 1380 },
  { label: '23:30', value: '23:30:00', compareValue: 1410 },
  { label: '24:00', value: '24:00:00', compareValue: 1440 }
]

export default {
  name: 'TimeSelector',
  components: { SelectComponent, BaseButton },
  props: {
    slotTime: {
      type: Object,
      required: true
    }
  },
  emits: ['update:slotTime'],
  data() {
    return {
      timeSlotSelected: null
    }
  },
  computed: {
    localSlotTime: {
      get() {
        return this.slotTime
      },
      set(value) {
        this.$emit('update:slotTime', value)
      }
    },
    fromHours() {
      let toHour = hours.find(
        (hour) => hour.value === this.localSlotTime.max
      )?.compareValue
      return hours.filter((hour) => hour.compareValue < toHour)
    },
    toHours() {
      let fromHour = hours.find(
        (hour) => hour.value === this.localSlotTime.min
      )?.compareValue
      return hours.filter((hour) => hour.compareValue > fromHour)
    },
    predefined_slots() {
      return [
        {
          label: this.$t('global.customize'),
          id: 'custom',
          gate: true,
          slotTime: {
            min: '07:00:00',
            max: '19:00:00'
          }
        },
        {
          label: this.$t('global.button.dashboard.agenda.business_hour'),
          id: 'business_hour',
          gate: true,
          slotTime: {
            min: '09:00:00',
            max: '18:00:00'
          }
        },
        {
          label: this.$t('global.button.dashboard.agenda.extended_hour'),
          id: 'extended_hour',
          gate: true,
          slotTime: {
            min: '06:00:00',
            max: '20:00:00'
          }
        },
        {
          label: this.$t('global.button.dashboard.agenda.whole_day'),
          id: 'whole_day',
          gate: true,
          slotTime: {
            min: '00:00:00',
            max: '24:00:00'
          }
        }
      ]
    }
  },
  watch: {
    timeSlotSelected(newValue, oldValue) {
      if (newValue !== oldValue && this.timeSlotSelected !== 'custom') {
        this.handlePredefinedSlot(
          this.predefined_slots.find(
            (predefined_slot) => predefined_slot.id === newValue
          )
        )
      }
    },
    'localSlotTime.min'(newValue, oldValue) {
      if (this.timeSlotSelected === 'custom') {
        this.$emit('update:slotTime', {
          ...this.localSlotTime,
          min: newValue
        })
      }
    },
    'localSlotTime.max'(newValue, oldValue) {
      if (this.timeSlotSelected === 'custom') {
        this.$emit('update:slotTime', {
          ...this.localSlotTime,
          max: newValue
        })
      }
    }
  },
  mounted() {
    this.setTimeSlotSelected()
  },
  methods: {
    handlePredefinedSlot(predefined_slot) {
      this.localSlotTime = Object.assign(
        {},
        {
          min: predefined_slot.slotTime.min,
          max: predefined_slot.slotTime.max
        }
      )
    },
    setTimeSlotSelected() {
      this.timeSlotSelected = 'custom'
      this.predefined_slots.forEach((slot) => {
        if (
          this.localSlotTime.min === slot.slotTime.min &&
          this.localSlotTime.max === slot.slotTime.max
        ) {
          this.timeSlotSelected = slot.id
        }
      })
    }
  }
}
</script>

<style scoped></style>
